'use client';
import { sendGTMEvent as sendGTMEventBase } from 'tracking';
import { GTMEvent } from './types';

/**
 * Extends the sendGTMEvent function from the core tracking package with a project-specific implementation.
 */

export const sendGTMEvent = (event: GTMEvent) => {
  sendGTMEventBase({
    pathname: window.location.pathname,
    ...event,
  });
};
